<template>
  <div v-if="section.id == 'proj2sect1'">
    <div v-if="isLeft(side)">
      <row-page-header>
        <span slot="title">Second Stage App &amp; Interaction Design</span>
        <span slot="category">Interaction Design, Research, Concept</span>
      </row-page-header>
      <div class="row">
        <div class="col-12">
          <p>
            As part of an Interaction Designs Methods class at SFU our team worked on a term project that explored various concepts in usability and interaction design. After weeks of utilizing these methods, th e project eventually lead to designing a concept for a digital solution for a local theatre company in Coquitlam named Second Storey Theatre.
          </p>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <row-vertical-center>
        <div class="row" :style="fakeContainerStyle()">
          <div class="col-6" v-for="(icons, index) in firstSectionIcons">
            <card :contents="icons"></card>
          </div>
        </div>
      </row-vertical-center>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect2' || section.id == 'proj2sect20'">
    <row-vertical-center>
      <div class="row">
        <div class="col-12 text-center">
          <row-section-header>
            <span slot="title">
              Concept Video
            </span>
          </row-section-header>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2 text-center">
          <div class="d-block d-md-none">
            <iframe src="https://player.vimeo.com/video/178370841" width="100%" height="auto" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div>
          <div class="d-none d-md-block">
            <iframe src="https://player.vimeo.com/video/178370841" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </row-vertical-center>
  </div>
  <div v-else-if="section.id == 'proj2sect3'">
    <div v-if="isLeft(side)" class="mx-auto">
      <row-section-header>
        <span slot="title">
          Task &amp; Project Format
        </span>
      </row-section-header>
      <div class="row">
        <div class="col-12">
          <p>
            At the beginning of the semester our team chose a group in order to carry out the project's user testing, concepts, and design approaches. The goal of the course was to apply various methods of interaction design strategies to a final concept directed toward the chosen group.
          </p>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row section-height py-5" :style="fakeContainerStyle()">
        <div class="col-12 mx-auto" v-for="(task, idx) in tasks">
          <row-column-header>
            <span slot="title">
              <span class="serif">{{ task.title }}</span>
            </span>
            <span slot="body">
              <ul>
                <li class="d-block" v-for="item in task.list">{{ item }}</li>
              </ul>
            </span>
          </row-column-header>
        </div>
      </div>
      <div class="bg-color-light-gray">
        <div class="row pt-5" :style="fakeContainerStyle()">
          <div class="col-12 col-md-6 v-align-wrapper section-height">
            <div class="v-align">
              <img class="img w-100 pt-3 pb-3" src="@/../static/Poster1-Ethnography1.png" alt="ethnography">
            </div>
          </div>
          <div class="col-12 col-md-6">
            <img class="img w-100 pt-3 pb-3" src="@/../static/Card1-Ethnography.png" alt="ethnography">
            <img class="img w-100 pt-3 pb-3" src="@/../static/Card2-Ethnography.png" alt="ethnography">
          </div>
          <div class="col-12">
            <p class="text-center pb-5">
              Each week we presented our data by creating visual documents that outlined our findings, as well as shared various elements from the usability methods we practiced.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect4'">
    <div v-if="isLeft(side)" class="mx-auto" width="100%">
      <row-section-header>
        <span slot="title">
          The Theatre &amp; The Players
        </span>
      </row-section-header>
      <div class="row">
        <div class="col-12">
          <p>
            The Second Storey Players are a formal group that get together at Second Storey Theatre on a weekly basis for performances and paid classes. To join this group, participants must audition every three months to cement their place in the program. This requires a certain level of skill and ability. The members share interests outside of the theatre and socialize as a group outside scheduled classes and shows.
          </p>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <!-- for mobile START -->
      <div class="d-block d-md-none">
        <div class="img-overflow y-hidden" style="margin-left: -15px; margin-right: -15px;">
          <img class="img w-100" src="@/../static/Players.jpg" alt="players">
        </div>
      </div>
      <!-- for mobile END -->
      <!-- for desktop START -->
      <div class="d-none d-md-block">
        <row-vertical-center>
          <div class="img-overflow y-hidden x-hidden section-height" :style="affixComponentStyle(1)">
            <img class="img h-100 img-h-100" src="@/../static/Players.jpg" alt="players">
          </div>
        </row-vertical-center>
      </div>
      <!-- for desktop END -->
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect5'">
    <div class="row section-height">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-4 offset-md-4">
            <row-section-header>
              <span slot="title">
                Understanding The Roles
              </span>
            </row-section-header>
            <p class="text-center mb-5 pb-5">
              There are four major human components to the Second Storey Theatre experience.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-md-2">
            <div class="row">
              <div class="col-12 col-md-3 card-image-bigger" v-for="(card, index) in roles">
                <card :contents="card"></card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect6'">
    <div v-if="isLeft(side)" class="mx-auto">
      <row-section-header>
        <span slot="title">
          The Engaging Experience
        </span>
      </row-section-header>
      <div class="row">
        <div class="col-6 offset-3">
          <img class="img pb-5 w-100" src="@/../static/Engaging-experience.svg" alt="engaging experience">
        </div>
      </div>
      <div class="row pb-5">
        <div class="col-12">
          <p class="text-center">
            Second Storey is built on the engagement between all stakeholders in the theatre experience
          </p>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row" :style="fakeContainerStyle()">
        <div class="col-12 mx-auto pb-5" v-for="(stakeholder, idx) in stakeholders">
          <row-vertical-center>
            <row-section-header>
              <span slot="title">
                <img class="img w-50 pb-5 d-block mx-auto" :src="['@/../static/' + stakeholder.img]" alt="stakeholder">
                <span class="serif">{{ stakeholder.title }}</span>
              </span>
            </row-section-header>
            <p class="text-center" v-for="paragraph in stakeholder.paragraphs">
              {{ paragraph }}
            </p>
          </row-vertical-center>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect10'">
    <div class="row section-height">
      <div class="col-12">
        <div class="row" :style="fakeContainerStyle()">
          <div class="col-12">
            <row-section-header>
              <span slot="title">
                Understanding The User’s World
              </span>
            </row-section-header>
          </div>
        </div>
        <div class="row pt-5" :style="fakeContainerStyle()">
          <div class="col-12 col-md-4 mb-5 pb-5" v-for="(card, index) in usersWorld">
            <card :contents="card"></card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect11'">
    <div class="row" :style="fakeContainerStyle()">
      <div class="col-12 col-md-8 offset-md-2">
        <row-section-header>
          <span slot="title">
            Concepts
          </span>
        </row-section-header>
        <p class="text-center">
          As part of the format we brainstormed various concepts and iterated them down to two main ideas. We took the Players’ passion for growth and refinement of craft, as well as the audience and theatre’s lively community, to create concepts that enrich the theatre experience.
        </p>
      </div>
      <div class="col-12 col-md-8 offset-md-2">
        <img class="img pt-5 pb-5 w-100 text-center" src="@/../static/Storyboard1.png" alt="interface example">
      </div>
    </div>
    <div class="row" :style="fakeContainerStyle()">
      <div class="col-12 col-md-8 offset-md-2">
        <img class="img pt-5 pb-5 w-100 text-center" src="@/../static/Storyboard2.png" alt="interface example">
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect15'">
    <div v-if="isLeft(side)" class="mx-auto">
      <row-section-header>
        <span slot="title">
          Goals
        </span>
      </row-section-header>
      <div class="row pb-5">
        <div class="col-12">
          <div class="mx-auto">
            <card :contents="cardStrengthen"></card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row pt-5 pb-5" :style="fakeContainerStyle()">
        <div class="col-12 mx-auto pt-5 mt-5">
          <h4 class="text-center serif strong">Training Tools</h4>
        </div>
        <div class="col-12 col-md-8 offset-md-2 mx-auto">
          <img class="img pt-5 pb-5 w-100 text-center" src="@/../static/Example-Players-TrainingCentre.png" alt="training center">
          <img class="img pt-5 pb-5 w-100 text-center" src="@/../static/EXAMPLE-Players-TrainingCentre2.png" alt="training center">
        </div>
        <div class="col-12">
          <p class="text-center pb-5">
            The Second Storey Players are dedicated and passionate about improving their skills, but can only meet limited times throughout the week. Having the tools to practice outside of meetings extends the platform for improvement.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect16'">
    <div v-if="isLeft(side)" class="mx-auto">
      <div class="row pb-5">
        <div class="col-12">
          <div class="mx-auto pt-5 mt-5">
            <card :contents="cardMentor"></card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row pt-5 pb-5" :style="fakeContainerStyle()">
        <div class="col-12 mx-auto pt-5 mt-5">
          <h4 class="text-center serif strong">Peer &amp; Director Feedback</h4>
        </div>
        <div class="col-12 col-md-8 offset-md-2 mx-auto">
          <img class="img pt-5 pb-5 w-100 text-center" src="@/../static/Example-Feedback.png" alt="feedback">
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect17'">
    <div v-if="isLeft(side)" class="mx-auto">
      <div class="row pb-5">
        <div class="col-12">
          <div class="mx-auto pt-5 mt-5">
            <card :contents="cardConnect"></card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row pt-5 pb-5" :style="fakeContainerStyle()">
        <div class="col-12 mx-auto pt-5 mt-5">
          <h4 class="text-center serif strong">Vote for a Game</h4>
        </div>
        <div class="col-12 col-md-8 offset-md-2 mx-auto">
          <img class="img pt-5 pb-5 w-100 text-center" src="@/../static/Example-Audience-Vote.png" alt="audience vote">
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj2sect18'">
    <div class="row" :style="fakeContainerStyle()">
      <div class="col-12 col-md-6 offset-md-3">
        <div class="mx-auto pt-5 mt-5">
          <card :contents="cardInform"></card>
        </div>
      </div>
    </div>
    <div class="row" :style="fakeContainerStyle()">
      <div class="col-12">
        <p class="text-center">
          Finally our last goal was to help both players and audiences alike be better equipped with knowledge about improv and theatre
        </p>
        <img class="img pt-5 pb-5 w-100 text-center" src="@/../static/Inform-Sequence.png" alt="audience vote">
      </div>
    </div>
  </div>
</template>

<script>
import AffixedSectionBase from '@/components/AffixedSectionBase.js'
import RowPageHeader from '@/components/rows/PageHeader.vue'
import RowSectionHeader from '@/components/rows/SectionHeader.vue'
import RowColumnHeader from '@/components/rows/ColumnHeader.vue'
import RowVerticalCenter from '@/components/rows/VerticalCenter.vue'
import Card from '@/components/Card.vue'
import AsyncAnimation from '@/components/AsyncAnimation.vue'

export default {
  name: 'project-2-section-1',
  mixins: [AffixedSectionBase],
  components: {
    Card,
    RowPageHeader,
    RowSectionHeader,
    RowColumnHeader,
    RowVerticalCenter,
    AsyncAnimation,
  },
  data: function () {
    return {
      firstSectionIcons: [
        {
          name: {
            text: 'Second Storey Theatre / Class Project',
            classes: ['little-small', 'strong'],
          },
          img: {
            path: '@/../static/ICONClient.svg',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: '10 Weeks',
            classes: ['little-small', 'strong'],
          },
          img: {
            path: '@/../static/ICONTimeline.svg',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'Team of 3',
            classes: ['little-small', 'strong'],
          },
          img: {
            path: '@/../static/ICONTeam.svg',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'Cross Platform',
            classes: ['little-small', 'strong'],
          },
          img: {
            path: '@/../static/ICONProjectType.svg',
            classes: ['w-50', 'mx-auto']
          },
        },
      ],
      tasks: [
        {
          title: 'Find Clients',
          list: ['Our team worked with local improv company in Coquitlam, Second Storey Theatre'],
        },
        {
          title: 'Study & Apply Design Methods',
          list: [
            'Quick & Dirty Ethnography',
            'Participant Groups',
            'Ethnography Data Analysis',
            'Cultural Probes',
            'Informances',
            'Personas',
            'Participatory Workshops',
            'Concepts & Sketches',
            'Storyboards & Journey Maps',
          ]
        },
        {
          title: 'Final Concept',
          list: [
            'Low Fidelity UI',
            'Presentation Video',
          ]
        },
      ],
      roles: [
        {
          name: {
            text: 'The Director',
            classes: ['little-small', 'strong', 'serif', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/ImageIcon-director.png',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'The Players',
            classes: ['little-small', 'strong', 'serif', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/ImageIcon-players.png',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'The Techies',
            classes: ['little-small', 'strong', 'serif', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/ImageIcon-techies.png',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'The Audience',
            classes: ['little-small', 'strong', 'serif', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/ImageIcon-Audience.png',
            classes: ['w-50', 'mx-auto']
          },
        },
      ],
      stakeholders: [
        {
          img: 'Icon-DIRECTOR-colour.svg',
          title: 'The Director',
          paragraphs: [
            "Owns and operates the Second Storey Theatre company in Coquitlam, BC",
            "Directs and MC’s shows, choosing what games are being played and eliciting instructions to the audience",
            "Works with actors during training sessions to help them grow and improve as performers",
          ],
        },
        {
          img: 'Icon-ACTORS-colour.svg',
          title: 'The Players',
          paragraphs: [
            "Work their way up from improv classes to becoming members of the regular performing group",
            "Under the direction of Graham, the company director, they meet weekly to practice their improv skills",
            "Always converge post-show to discuss the night’s show, work on improvements and critique each other’s performance",
          ],
        },
        {
          img: 'Icon-AUDIENCE-colour.svg',
          title: 'The Audience',
          paragraphs: [
            "Encouraged to engage when prompted (yelling suggestions, answers, participation games, etc.)",
            "Supports the theatre through ticket sales, concession sales, word of mouth advertising",
            "Potential to become part of the acting community by signing up with the Second Storey Improv group",
          ],
        },
        {
          img: 'Icon-TECHIE-colour.svg',
          title: 'The Techies',
          paragraphs: [
            "Made up of a small collection of members in the improv group, taking turns running the booth at shows",
            "Support the show by adding sound effects, lighting, and other technological help",
            "Need to have quick access to resources, such as sound bites and music, in order to effectively support audience suggestions and improv gestures",
          ],
        },
      ],
      usersWorld: [
        {
          name: {
            text: 'Cultural Probes',
            classes: ['little-small', 'serif', 'strong', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/Cultural-Probe-CLUSTER.png',
            classes: ['w-50', 'mx-auto']
          },
          desc: {
            text: "Seek out inspirational data with cultural probes (equipped with artifacts such as mood cards, madlibs, postcards) and given to different stakeholders in the company",
            classes: [],
          },
        },
        {
          name: {
            text: 'Participatory Workshops',
            classes: ['little-small', 'serif', 'strong', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/Participatory-Workshop-Cluster.png',
            classes: ['w-50', 'mx-auto']
          },
          desc: {
            text: "Seek out how stakeholders create and think about their craft through participatory exercises, such as collaging, sketching, and brainstorming",
            classes: [],
          },
        },
        {
          name: {
            text: 'Informances',
            classes: ['little-small', 'serif', 'strong', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/informance-screenshot-square.jpg',
            classes: ['w-50', 'mx-auto']
          },
          desc: {
            text: "Explore potential painpoints and design solutions by roleplaying scenarios in informance videos.",
            classes: [],
          },
        },
      ],
      cardStrengthen: {
        name: {
          text: 'Strengthen',
          classes: ['serif', 'strong', 'pt-2', 'pb-2'],
        },
        img: {
          path: '@/../static/Icon-StrengthBLACK.png',
          classes: ['w-25', 'mx-auto']
        },
        desc: {
          text: "Actors already create personal goals and utilize feedback from their peers and directors. One goal was to help facilitate this process throughout all the channels of the Second Storey Theatre system.",
          classes: ['text-center'],
        },
      },
      cardMentor: {
        name: {
          text: 'Mentor',
          classes: ['serif', 'strong', 'pt-2', 'pb-2'],
        },
        img: {
          path: '@/../static/Icon-MentorBLACK.png',
          classes: ['w-25', 'mx-auto']
        },
        desc: {
          text: "Actors have a close relationship with the director who strives to bring out the best in all his players. The concept seeks to help the players access this mentorship beyond the limits of the theatre floor.",
          classes: ['text-center'],
        },
      },
      cardConnect: {
        name: {
          text: 'Connect',
          classes: ['serif', 'strong', 'pt-2', 'pb-2'],
        },
        img: {
          path: '@/../static/Icon-connectBLACK.png',
          classes: ['w-25', 'mx-auto']
        },
        desc: {
          text: "The Second Storey Theatre group plays to a comparatively small community but has the potential to grow. In order to grow the theatre we aimed to strengthen the theatre connecting the community together, increasing ways for the audience to interact with the theatre experience.",
          classes: ['text-center'],
        },
      },
      cardInform: {
        name: {
          text: 'Inform',
          classes: ['serif', 'strong', 'pt-2', 'pb-2'],
        },
        img: {
          path: '@/../static/Icon-informBLACK.png',
          classes: ['w-25', 'mx-auto']
        },
      }
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
.card-image-bigger>.card>img.w-50 {
  width: 80%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/sections/projects/project2/Section1.vue